import { Pipe, PipeTransform } from '@angular/core';
import { IPayload } from 'src/app/models/facility';

@Pipe({
  name: 'facility'
})
export class FacilityPipe implements PipeTransform {

  transform(value: IPayload, ...args: any[]): string {
    let result = '';
    result = [value.addressLine1 === 'Unknown' ? false : value.addressLine1,
    value.addressLine3 === 'Unknown' ? false : value.addressLine3,
    value.city === 'Unknown' ? false : value.city,
    value.state === 'Unknown' ? false : value.state,
    value.country === 'Unknown' ? false : value.country,
    value.postalCode === 'Unknown' ? false : value.postalCode
    ].filter(Boolean).join(', ');
    return result;
  }

}